import React from 'react';

export const BackIcon = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5005 7.00035C15.5005 7.16611 15.4346 7.32508 15.3174 7.44229C15.2002 7.5595 15.0413 7.62535 14.8755 7.62535H2.63409L7.19268 12.1832C7.25075 12.2412 7.29681 12.3102 7.32824 12.386C7.35966 12.4619 7.37584 12.5432 7.37584 12.6253C7.37584 12.7075 7.35966 12.7888 7.32824 12.8647C7.29681 12.9405 7.25075 13.0095 7.19268 13.0675C7.13461 13.1256 7.06567 13.1717 6.9898 13.2031C6.91393 13.2345 6.83261 13.2507 6.75049 13.2507C6.66837 13.2507 6.58705 13.2345 6.51118 13.2031C6.43531 13.1717 6.36637 13.1256 6.3083 13.0675L0.683304 7.44254C0.625194 7.38449 0.579095 7.31556 0.547642 7.23969C0.516189 7.16381 0.5 7.08248 0.5 7.00035C0.5 6.91821 0.516189 6.83688 0.547642 6.76101C0.579095 6.68514 0.625194 6.61621 0.683304 6.55816L6.3083 0.93316C6.42558 0.815885 6.58464 0.75 6.75049 0.75C6.91634 0.75 7.0754 0.815885 7.19268 0.93316C7.30996 1.05044 7.37584 1.2095 7.37584 1.37535C7.37584 1.5412 7.30996 1.70026 7.19268 1.81753L2.63409 6.37535H14.8755C15.0413 6.37535 15.2002 6.4412 15.3174 6.55841C15.4346 6.67562 15.5005 6.83459 15.5005 7.00035Z"
      fill="white"
    />
  </svg>
);
